module.exports = __webpack_public_path__ + "assets/img/video-guide.6860d4a7.webp";